/**
 * Microservice identifiers
 * Add new microservices here as they are integrated into the system
 */
export const MICROSERVICES = {
    KNOWLEDGE_BASE: 'kb',
    VIRTUAL_ASSISTANT: 'va',
    UI_MANAGER: 'ui'
} as const;

/**
 * Type-safe microservice identifier
 */
export type MicroserviceId = (typeof MICROSERVICES)[keyof typeof MICROSERVICES];

/**
 * Microservice configuration interface
 */
export interface MicroserviceConfig {
    id: MicroserviceId;
    name: string;
    description: string;
}

/**
 * Available microservices metadata
 */
export const MICROSERVICE_REGISTRY: Record<MicroserviceId, MicroserviceConfig> = {
    [MICROSERVICES.KNOWLEDGE_BASE]: {
        id: 'kb',
        name: 'Knowledge Base',
        description: 'File management, knowledge bases, and chunking strategies'
    },
    [MICROSERVICES.VIRTUAL_ASSISTANT]: {
        id: 'va',
        name: 'Virtual Assistant',
        description: 'Mother agents, virtual agents, intents, and playground'
    },
    [MICROSERVICES.UI_MANAGER]: {
        id: 'ui',
        name: 'UI Manager',
        description: 'Chatbot configuration and UI customization'
    }
};
